<template>
  <div>
    <el-row :gutter="10" style="margin-top:-15px">
      <el-col :span="6">
        <div class="title-context"
          style="background:-webkit-gradient(linear, 0% 0%, 0% 100%, from(#91CBEF), to(#0D9DF7));">
          <el-row>
            <div class="context-div">
              <el-col :span="6">
                <div @click="add_repair_tab()">
                  <el-row class="context-value">
                    {{ faultInfo.nofinishRepair }}
                  </el-row>
                  <el-row class="context-key">
                    现存维修
                  </el-row>
                </div>
              </el-col>
              <el-col :span="6">
                <div @click="add_repair_tab()">
                  <el-row class="context-value">
                    {{ faultInfo.todayOccuRepairCount }}
                  </el-row>
                  <el-row class="context-key">
                    今日维修
                  </el-row>
                </div>
              </el-col>
              <el-col :span="6">
                <div @click="add_repair_tab()">
                  <el-row class="context-value">
                    {{ faultInfo.todaySolveRepairCount }}
                  </el-row>
                  <el-row class="context-key">
                    今日解决
                  </el-row>
                </div>
              </el-col>
              <el-col :span="6">
                <i class="el-icon-font el-icon-weixiubeijing el-icon--left context-icon" style="color:#0D9DF7;"></i>
              </el-col>
            </div>
          </el-row>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="title-context"
          style="background:-webkit-gradient(linear, 0% 0%, 0% 100%, from(#BBEE6E), to(#528406));">
          <el-row>
            <div class="context-div">
              <el-col :span="8">
                <div @click="add_mat_tab()">
                  <el-row class="context-value">
                    {{ faultInfo.matConsumes == null ? 0 : faultInfo.matConsumes }}
                  </el-row>
                  <el-row class="context-key">
                    故障材料使用
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <div @click="add_mat_tab()">
                  <el-row class="context-value">
                    {{ faultInfo.matRepairConsumes }}
                  </el-row>
                  <el-row class="context-key">
                    维修材料使用
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <i class="el-icon-font el-icon-chakan el-icon--left context-icon" style="color:#528406;"></i>
              </el-col>
            </div>
          </el-row>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="title-context"
          style="background:-webkit-gradient(linear, 0% 0%, 0% 100%, from(#EEA86E), to(#F1750F));">
          <el-row>
            <div class="context-div">
              <el-col :span="8">
                <div @click="add_task_tab()">
                  <el-row class="context-value">
                    {{ faultInfo.todayTaskCount == null ? 0 : faultInfo.todayTaskCount }}
                  </el-row>
                  <el-row class="context-key">
                    今日任务
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <div @click="add_task_tab()">
                  <el-row class="context-value">
                    {{ faultInfo.todayFinishTaskCount }}
                  </el-row>
                  <el-row class="context-key">
                    今日完成任务
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <i class="el-icon-font el-icon-task el-icon--left context-icon" style="color:#F1750F;"></i>
              </el-col>
            </div>
          </el-row>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="title-context"
          style="background:-webkit-gradient(linear, 0% 0%, 0% 100%, from(#C79AD3), to(#C72FEF));">
          <el-row>
            <div class="context-div">
              <el-col :span="8">
                <div @click="add_maintain_tab()">
                  <el-row class="context-value">
                    {{ faultInfo.todayMaintainCount == null ? 0 : faultInfo.todayMaintainCount }}
                  </el-row>
                  <el-row class="context-key">
                    今日保养
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <div @click="add_maintain_tab()">
                  <el-row class="context-value">
                    {{ faultInfo.todayFinishMaintainCount }}
                  </el-row>
                  <el-row class="context-key">
                    今日完成保养
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <i class="el-icon-font el-icon-yiyaoxiang el-icon--left context-icon" style="color:#C72FEF;"></i>
              </el-col>
            </div>
          </el-row>
        </div>
      </el-col>
      <el-col :span="12">
        <el-card style="margin-top: 15px;height:  215px;">
          <el-col :span="16">
            <div class="context-div">
              <el-col :span="8">
                <div @click="add_fau_tab()" style="margin-top: 15px;">
                  <el-row class="tatistic-value">
                    {{ faultlist.length }}
                  </el-row>
                  <el-row class="tatistic-key">
                    现存故障数
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <div @click="add_fau_tab()" style="margin-top: 15px;">
                  <el-row class="tatistic-value">
                    {{ faultInfo.todayOccuCount }}
                  </el-row>
                  <el-row class="tatistic-key">
                    今日发生故障数
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <div @click="add_fau_tab()" style="margin-top: 15px;">
                  <el-row class="tatistic-value">
                    {{ faultInfo.todaySolveCount }}
                  </el-row>
                  <el-row class="tatistic-key">
                    今日解决故障数
                  </el-row>
                </div>
              </el-col>
            </div>
          </el-col>
          <el-col :span="8">
            <div @click="add_fau_tab()" id="finishRatePanel" style="height:180px;"></div>
          </el-col>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card style="margin-top: 15px;height:  215px;">
          <el-col :span="16">
            <div class="context-div">
              <el-col :span="8">
                <div @click="add_ins_tab()" style="margin-top: 15px;">
                  <el-row class="tatistic-value">
                    {{ faultInfo.planCount == null ? 0 : faultInfo.planCount }}
                  </el-row>
                  <el-row class="tatistic-key">
                    今日巡检计划
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <div @click="add_ins_tab()" style="margin-top: 15px;">
                  <el-row class="tatistic-value">
                    {{ faultInfo.todayPlanItemCount }}
                  </el-row>
                  <el-row class="tatistic-key">
                    今日巡检项
                  </el-row>
                </div>
              </el-col>
              <el-col :span="8">
                <div @click="add_ins_tab()" style="margin-top: 15px;">
                  <el-row class="tatistic-value">
                    {{ faultInfo.todayFinishPlanItemCount }}
                  </el-row>
                  <el-row class="tatistic-key">
                    今日完成巡检项
                  </el-row>
                </div>
              </el-col>
            </div>
          </el-col>
          <el-col :span="8">
            <div @click="add_ins_tab()" id="insFinishRatePanel" style="height:180px;"></div>
          </el-col>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-row :gutter="15">
          <el-col>
            <el-card style="margin-top: 15px;height:  150px;">
              <el-col :span="6">
                <div @click="add_user_tab()" class="tatistic-div">
                  <el-row class="tatistic-value">
                    <div style="margin-top: 20px;">
                      {{ faultInfo.userCount }}
                    </div>
                  </el-row>
                  <el-row class="tatistic-key">
                    现场人员
                  </el-row>
                </div>
              </el-col>
              <el-col :span="6">
                <div @click="add_duty_tab()" class="tatistic-div">
                  <el-row class="tatistic-value">
                    <div style="margin-top: 20px;">
                      {{ faultInfo.dutyCount }}
                    </div>
                  </el-row>
                  <el-row class="tatistic-key">
                    在班人员
                  </el-row>
                </div>
              </el-col>
              <el-col :span="6">
                <div @click="add_user_tab()" class="tatistic-div">
                  <el-row class="tatistic-value">
                    <div style="margin-top: 20px;">
                      {{ faultInfo.userCount - faultInfo.dutyCount }}
                    </div>
                  </el-row>
                  <el-row class="tatistic-key">
                    休假人员
                  </el-row>
                </div>
              </el-col>
              <el-col :span="6">
                <div @click="add_asset_tab()" class="tatistic-div" style="">
                  <el-row class="tatistic-value">
                    <div style="margin-top: 20px;">
                      {{ faultInfo.assetCount }}
                    </div>
                  </el-row>
                  <el-row class="tatistic-key">
                    设备管理
                  </el-row>
                </div>
              </el-col>
            </el-card>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-card style="margin-top: 15px;height: calc(100vh - 685px);">
              <div id="eleDayFaultHis" @click="add_fau_tab()"
                style="margin-top: 15px;height: calc(100vh - 700px);overflow-y: auto;">
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <div @click="add_fau_tab()">
          <el-card style="margin-top: 15px;overflow-y: auto;">
            <el-table :data="faultInfo.nofinishFaults" ref="fauTable" show-overflow-tooltip border stripe size="mini"
              height="calc(100vh - 545px)" v-loading="loading">
              <el-table-column type="index" label="序号" width="50" align="center">
              </el-table-column>
              <el-table-column prop="org_name" label="组织名称">
              </el-table-column>
              <el-table-column prop="area_name" label="区域名称">
              </el-table-column>
              <el-table-column prop="equi_name" label="设备名称">
              </el-table-column>
              <el-table-column prop="code" label="故障单号">
              </el-table-column>
              <el-table-column prop="level_name" label="故障等级">
              </el-table-column>
              <el-table-column prop="appe_name" label="故障现象">
                <template slot-scope="scope">
                  <span>{{ scope.row.appe_id == 999999 ? (scope.row.des == null ? '' : scope.row.des) :
                      scope.row.appe_name
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="occu_time" label="故障上报时间">
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dateutils from '../utils/dateutils.js'
export default {
  name: 'eshome',

  data () {
    return {
      loading: false,
      queryObj: { starttime: [], endtime: [] },//查询条件 
      dayFaultHis: [],
      faultlist: [],
      faultInfo: {},

    }
  },
  methods: {
    init () {
      this.getOutlinedata()
      this.loadDayFaultHis()
    },
    getOutlinedata () {
      this.$ajax.get('/buss/home/get_outlinedata').then((msg) => {
        this.faultInfo = msg
        this.faultlist = msg.nofinishFaults

        //故障完成率
        let alarmchart = this.$echarts.init(document.getElementById('finishRatePanel'))
        let alarmoption = {
          series: [
            {
              type: 'gauge',
              radius: '100%',
              detail: {
                formatter: '{value}%',
                fontSize: 14,
                color: '#ddd'
              },
              data: [
                {
                  title: {
                    show: true,
                    fontSize: 16,
                    offsetCenter: [0, 80],
                    color: '#ddd'
                  },
                  value: msg.todayOccuCount == 0 ? 100 : (msg.todaySolveCount * 100 / msg.todayOccuCount).toFixed(2),
                  name: '故障完成率'
                }
              ],
              axisLine:
              {
                lineStyle: {
                  color: [[0.2, '#c23531'], [0.8, 'orange'], [1, 'green']]
                }
              }
            }
          ]
        }
        alarmchart.setOption(alarmoption);

        //巡检完成率
        alarmchart = this.$echarts.init(document.getElementById('insFinishRatePanel'))
        alarmoption = {
          series: [
            {
              type: 'gauge',
              radius: '100%',
              detail: {
                formatter: '{value}%',
                fontSize: 14,
                color: '#ddd'
              },
              data: [
                {
                  title: {
                    show: true,
                    fontSize: 16,
                    offsetCenter: [0, 80],
                    color: '#ddd'
                  },
                  value: msg.todayPlanItemCount == 0 ? 100 : (msg.todayFinishPlanItemCount * 100 / msg.todayPlanItemCount).toFixed(2),
                  name: '巡检完成率'
                }
              ],
              axisLine:
              {
                lineStyle: {
                  color: [[0.2, '#c23531'], [0.8, 'orange'], [1, 'green']]
                }
              }
            }
          ]
        }
        alarmchart.setOption(alarmoption);

      }).catch(err => {
        this.$message.error(err)
      })
    },
    loadDayFaultHis () {
      this.queryObj.starttime = dateutils.dateFormat("YYYY-mm-01 00:00:00", new Date())
      this.queryObj.endtime = dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())
      this.$ajax.get('/buss/statisticfault/dayfaulthis', this.queryObj).then(msg => {
        this.dayFaultHis = msg
        this.initLineDayFaultHis(this.dayFaultHis, "eleDayFaultHis", "")
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    initLineDayFaultHis (datelist, idname, title) {

      let myChart = this.$echarts.init(document.getElementById(idname))

      let names = []
      let datechart = []
      for (var i = 0; i < datelist.length; i++) {
        names.push(datelist[i].name)
        datechart.push(datelist[i].value)
      }

      var option = {
        title: {
          text: title,
          textAlign: 'auto'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: names
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '故障数',
            data: datechart,
            type: 'line',
            smooth: true
          }
        ]
      }
      myChart.setOption(option)
    },
    add_fau_tab () {
      if (this.$store.getUser().menus.indexOf('/fault/faultquery') >= 0) {
        this.$emit("add-tab", {
          "id": 48,
          "label": "故障查询",
          "icon": "el-icon-yulanchakan",
          "url": "/fault/faultquery"
        })
      } else {
        this.$message.error("你没有故障查询权限")
      }
    },
    add_ins_tab () {
      if (this.$store.getUser().menus.indexOf('/ins/insmanage') >= 0) {
        this.$emit("add-tab", {
          "id": 65,
          "label": "巡检计划",
          "icon": "el-icon-jihua",
          "url": "/ins/insmanage",
        })
      } else {
        this.$message.error("你没有巡检计划查看权限")
      }
    },
    add_task_tab () {
      if (this.$store.getUser().menus.indexOf('/task/taskquery') >= 0) {
        this.$emit("add-tab", {
          "id": 72,
          "label": "任务查看",
          "icon": "el-icon-chaxun",
          "url": "/task/taskquery",
        })
      } else {
        this.$message.error("你没有任务查看权限")
      }
    },
    add_maintain_tab () {
      if (this.$store.getUser().menus.indexOf('/maintain/maintainquery') >= 0) {
        this.$emit("add-tab", {
          "id": 92,
          "label": "保养查看",
          "icon": "el-icon-paibanchaxun",
          "url": "/maintain/maintainquery"
        })
      } else {
        this.$message.error("你没有保养查看权限")
      }
    },
    add_mat_tab () {
      if (this.$store.getUser().menus.indexOf('/mat/matconsumequery') >= 0) {
        this.$emit("add-tab", {
          "id": 38,
          "label": "物料使用",
          "icon": "el-icon-chakan",
          "url": "/mat/matconsumequery"
        })
      } else {
        this.$message.error("你没有物料使用查看权限")
      }

    },
    add_user_tab () {
      if (this.$store.getUser().menus.indexOf('/system/account') >= 0) {
        this.$emit("add-tab", {
          "id": 12,
          "label": "账户管理",
          "icon": "el-icon-yonghu",
          "url": "/system/account",
        })
      } else {
        this.$message.error("你没有账户管理权限")
      }
    },
    add_repair_tab () {
      if (this.$store.getUser().menus.indexOf('/repair/repairquery') >= 0) {
        this.$emit("add-tab", {
          "id": 12,
          "label": "维修查看",
          "icon": "el-icon-yulanchakan",
          "url": "/repair/repairquery",
        })
      } else {
        this.$message.error("你没有维修查看权限")
      }
    },
    add_duty_tab () {
      if (this.$store.getUser().menus.indexOf('/rostering/rosteringnowduty') >= 0) {
        this.$emit("add-tab", {
          "id": 84,
          "label": "在班人员",
          "icon": "el-icon-jihua",
          "url": "/rostering/rosteringnowduty",
        })
      } else {
        this.$message.error("你没有在班人员权限")
      }
    },
    add_asset_tab () {
      if (this.$store.getUser().menus.indexOf('/asset/asset') >= 0) {
        this.$emit("add-tab", {
          "id": 21,
          "label": "设备管理",
          "icon": "el-icon-shebeizuguanli",
          "url": "/asset/asset",
        })
      } else {
        this.$message.error("你没有设备管理权限")
      }
    }
  },

  mounted () {
    this.init()
  },

}
</script>

<style  scoped>
.card-context {
  height: 200px;
}

.title-context {
  height: 160px;
  border-radius: 10px;
  margin-top: 10px;
}

.context-div {
  margin-left: 10px;
  margin-top: 50px;
  text-align: center;
}

.context-value {
  color: white;
  font-size: 32px;
}

.context-key {
  color: #ddd;
  font-size: 14px;
  margin-top: 10px;
}

.tatistic-div {
  height: 90px;
  background: #e1e3f6;
  border-radius: 5px;
  margin-top: 20px;
  text-align: center;
}

.tatistic-value {
  color: rgb(68, 67, 67);
  font-size: 28px;
}

.tatistic-key {
  color: rgb(126, 125, 125);
  margin-top: 10px;
  font-size: 12px;
}

.context-icon {
  font-size: 40px;
  font-weight: 500;
  margin-top: -20px;
  margin-right: -10px;
}

.card-table {
  height: calc(100vh - 730px);
}

.card-con {
  height: calc(100vh - 350px);
}

.el-aside {
  /* background-color: #8dccf7; */
  color: rgb(255, 255, 255);
  text-align: center;
  line-height: 90px;
}

.el-main {
  /* background-color: #a2d7f9; */
  color: rgb(247, 251, 251);
  text-align: center;
  line-height: 50px;
}
</style>
